
<script>
import GameVerticalPhotoCard from "./GameVerticalPhotoCard.vue";

export default {
  components: {
    GameVerticalPhotoCard,
  },
  props: {
    imageList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      gamesData: [],
      swiperOption: {
        speed: 1500,
        slidesPerView: 6,
        centeredSlides: true,
        spaceBetween: 40,
        grabCursor: true,
        loop: true,

        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },

        breakpoints: {
          1024: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 2,
            spaceBetween: 20,
            width: 403,
          },
        },

        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
      },
    };
  },
   watch: {
    imageList(newVal) {
      console.warn('newVal', newVal)
      if (newVal && newVal.length > 0) {
        const data = newVal.filter(item => item.image)
        this.gamesData = data.concat(data)
      }
    },
  },
  mounted() {},
  created() {
    const games = [
      {
        image: "app-photo-1@2x.jpg",
      },
      {
        image: "app-photo-2@2x.jpg",
      },
      {
        image: "app-photo-3@2x.jpg",
      },
      {
        image: "app-photo-4@2x.jpg",
      },
      {
        image: "app-photo-5@2x.jpg",
      },
      {
        image: "app-photo-6@2x.jpg",
      },
    ];

    if(this.imageList?.length > 0) {
      const data = this.imageList.filter(item => item.image)
      this.gamesData = data.concat(data)
    } else {
      this.gamesData = games.concat(games)
    }
  },
};
</script>


<template>
  <div class="w-100 learn_play_slider d-inline-block">
    <div class="learn_play_animate animateToLeft">
      <div
        v-for="(game, index) in gamesData"
        :key="index"
        :class="[{ cardVerticalGap: index % 2 }]"
        class="single_block"
      >
        <GameVerticalPhotoCard :game="game" />
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.cardVerticalGap {
  position: relative;
  top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
</style>
